<template>
  <div class="h-100">
    <div class="d-flex flex-column flex-root align-items-stretch h-100">
      <div class="page d-flex flex-row align-items-stretch flex-column-fluid">

        <div class="wrapper d-flex flex-column flex-row-fluid custom-back" id="kt_wrapper">
          <app-header :logo="true" :numberNotification="getNotificationCount"></app-header>
          <router-view  v-if="!isAppLoaded && getSelectCompanyId"/>
          <app-footer></app-footer>
          <NotificationDrawer  :notifications="getNotifications"/>
          <InstallPwaBanner/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppFooter from './partials/AppFooter.vue'
import AppHeader from './partials/AdjustedAppHeader.vue'
import AppMenu from './partials/AppMenu.vue'
import AppMenu2 from './partials/AppMenu2.vue'
import {mapGetters, mapActions, useStore} from "vuex";
import Ls from "@/services/ls";
import {useLocales} from "@/composables/locales";
import Img from '@/components/Img.vue';
import { getTenantId } from '@/mixins/Helpers'
import NotificationDrawer from "@/components/Notification/Notification.vue";
import InstallPwaBanner from '@/components/InstallPwaBanner.vue';

export default {
  data() {
    const { setLocale, locale } = useLocales()
    return {
      notifications: [],
      formCreateData: {
        object: '',
        value: '',
        description: '',
      },
      getSupportObjets : [],
      getObjetValues : [],
      filteredObjectValuesData: [],
      setLocale,
      locale
    }
  },

  components: {
    NotificationDrawer,
    AppFooter, AppHeader, AppMenu, Img, AppMenu2,InstallPwaBanner
  },

  computed: {
    ...mapGetters('permission', [
      'permissions'
    ]),

    ...mapGetters('notifications',[
      'getNotificationCount',
      'getNotifications',
    ]),

    ...mapGetters(['isAppLoaded']),

    ...mapGetters('offices' , [
        'getSelectCompanyId'
    ]),


    tenantId(){
      return getTenantId()?.slice(0, -1)
    },

  },


  updated() {
    this.$nextTick(() => {
      this.initComponents()
    })
  },

  async mounted() {
    await this.loadNotifications()
    await axios.get('push-notification/key')
        .then((response) => {
          this.publicKey = response.data.key
        })
        .catch((error) => {

        })

    if (('Notification' in window) && ('serviceWorker' in navigator))  {
      await this.AskPermissionToNotify()
    }

    this.handleLocale()
    await  this.listenNewNotification()

    await this.getCurrentUser()
    this.initComponents()

  },

  methods: {
    ...mapActions('user', [
      'getCurrentUser'
    ]),

    ...mapActions(['toggleAsideState']),

    ...mapActions('notifications',[
      'loadNotifications',
      'listenNewNotification',
    ]),


    initComponents(){
      KTMenu.init();
      KTDrawer.init();
      KTToggle.init()
      KTUtil.init()
      KTApp.init()
    },

    handleLocale() {
      const locale = Ls.get('locale')
      if(locale) {
        this.setLocale(locale)
      }
    },

    toggleAside() {
      this.toggleAsideState()
    },

    async AskPermissionToNotify() {
      if (Notification.permission !== "granted") {
        this.permissionPushNotification = await Notification.requestPermission()
      }else{
        this.permissionPushNotification = Notification.permission
      }

      if (this.permissionPushNotification === "granted") {
        let registration = await navigator.serviceWorker.getRegistration()
        let subscription = await registration.pushManager.getSubscription()
        if (!subscription && this.publicKey) {
          subscription = registration.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: this.publicKey
          })
          subscription.then(async (value) => {
            await this.saveSubscription(value)
          })
        }else{
          await this.saveSubscription(subscription)
        }
      }
    },

    async saveSubscription(subscription) {
      if(subscription){
        await window.axios.post('/push-notification/saveSubscription', subscription.toJSON())
      }
    }

  }

}
</script>

<style scoped>
.aside-enabled.aside-fixed[data-kt-aside-minimize=on] .wrapper {
  transition: padding-left .3s ease;
  padding-left: 0px !important;
}

@media (min-width: 992px) {
    .header-fixed.toolbar-fixed .wrapper {
         padding-top: 65px !important; 
    }
}

</style>

